'use strict';

var n=(r,l)=>{let t={};if(localStorage){let e=localStorage.getItem(l);if(e!==null)try{t=JSON.parse(e)||{};}catch{t[r]=e;}}return t[r]},a=(r,l,t)=>{if(localStorage){let e=localStorage.getItem(t),o={};e!==null&&(o=JSON.parse(e)||{}),o[r]=l,localStorage.setItem(t,JSON.stringify(o));}};

exports.a = n;
exports.b = a;
